import CloseIcon from '@mui/icons-material/Close';
import { Modal } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

interface InspectionDetailModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  details: any;
}

export default function InspectionDetailModal({
  open,
  onClose,
  setOpen,
  details,
}: InspectionDetailModalProps) {
  const image = Array.isArray(details?.image)
    ? details.image[0]
    : details?.image || '/static/images/vehicle_side.jpg';
  return (
    <Modal
      className="modal fcDetail_modal"
      id="fcDetailModal"
      aria-labelledby="fcDetail-modal-title"
      aria-describedby="fcDetail-modal-description"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="btn-close" onClick={() => setOpen(false)}>
            <CloseIcon />
          </div>
          <div className="modal_title">
            <h2>Inspection Details</h2>
          </div>
          <div className="fcustomer_info gap_m">
            <div className="left_s">
              <figure className="blog_dtl_img">
                <img src={image} alt="" aria-hidden="true" />
              </figure>
            </div>
            <div className="right_s">
              <div className="fcComment_box" style={{ marginTop: '10px' }}>
                <h2>User Details</h2>
                <ul className="inspection_dtl_list">
                  <li>
                    <figure>
                      <img
                        src={details?.userImage || '/static/images/user_attachment.jpg'}
                        alt=""
                      />
                    </figure>
                    <p>
                      <b>{details?.userName || '-'}</b>
                      <b>{details?.userEmail || '-'}</b>
                      <b>{details?.userPhoneNo || '-'}</b>
                    </p>
                  </li>
                </ul>
              </div>
              <div className="fcComment_box" style={{ marginTop: '10px' }}>
                <h2>Seller Details</h2>
                <ul className="inspection_dtl_list">
                  <li>
                    <figure>
                      <img
                        src={details?.sellerImage || '/static/images/user_attachment.jpg'}
                        alt=""
                      />
                    </figure>
                    <p>
                      <b>{details?.sellerName || '-'}</b>
                      <b>{details?.sellerEmail || '-'}</b>
                      <b>{details?.sellerPhoneNo || '-'}</b>
                    </p>
                  </li>
                </ul>
              </div>
              <div className="details_md">
                <h3>Vehicle Id</h3>
                <p>{details?.VehicleId || '-'}</p>
                <h3>Vehicle Name</h3>
                <p>{details?.title}</p>
                <h3>Store Address</h3>
                <p>{details?.sellerAddress?.address || '-'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
